import { render, staticRenderFns } from "./BaseTableBox.vue?vue&type=template&id=0b04e1d4&scoped=true"
import script from "./BaseTableBox.vue?vue&type=script&lang=js"
export * from "./BaseTableBox.vue?vue&type=script&lang=js"
import style0 from "./BaseTableBox.vue?vue&type=style&index=0&id=0b04e1d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b04e1d4",
  null
  
)

export default component.exports